// extracted by mini-css-extract-plugin
export default {"box":"menuCom_box__MASE+"};